<template>
  <mdbModal centered elegant scrollable :show="mostrarModal" @close="mostrarModal = false">
    <mdbModalHeader>
      <mdbModalTitle>
        Detalle de actividad
      </mdbModalTitle>
    </mdbModalHeader>
    <mdbModalBody>
      <div>
        <div v-if="!Object.keys(preDetalle).length && !datosFactura" class="alerta advertencia p-4 mb-3 rounded text-center">
          <font-awesome-icon icon="exclamation-circle" size="3x" class="mb-2" />
          <p class="font-weight-bold mb-0">¿Verificaste las acciones a guardar?</p>
          <p class="mb-0 small">Esta actividad no contiene pedido ni pago asociado</p>
        </div>
        <div v-if="Object.keys(preDetalle).length">
          <h6 class="font-weight-bold mb-3">
            <font-awesome-icon icon="clipboard-list" class="mr-2 text-muted" />
            Lista de pedido
          </h6>

          <div v-for="(item, categoria) in preDetalle" :key="categoria" class="mb-4">
            <p class="small-block text-uppercase mb-2">
              <font-awesome-icon icon="angle-right" class="mr-1" />
              {{ categoria }}
            </p>

            <mdbCard v-for="(grupo, idProducto) in item" :key="idProducto" class="mb-3 card-bordered">
              <mdbCardBody class="py-3">
                <p class="font-weight-bold mb-2 texto-primario">
                  <font-awesome-icon icon="boxes" class="mr-2" />
                  {{ grupo[0].nom_pro }}
                </p>
                <div class="pl-3">
                  <div v-for="(pre, i) in grupo" :key="i" class="d-flex justify-content-between align-items-center py-1 border-bottom" :class="{'border-bottom-0': i === grupo.length - 1}">
                    <div>
                      <span class="font-weight-medium">{{ pre.des_pre }}</span>
                      <span class="text-muted ml-2">({{ pre.paq_pre }})</span>
                    </div>
                    <mdbBadge color="bg-primario" pill>
                      Cant: {{ pre.cantidad }}
                    </mdbBadge>
                  </div>
                </div>
              </mdbCardBody>
            </mdbCard>
          </div>
        </div>
        <hr v-if="documento" class="my-4">
        <mdbCard v-if="documento" class="mb-3 card-bordered">
          <mdbCardBody>
            <div class="d-flex justify-content-between align-items-center mb-2">
              <mdbCardTitle class="mb-0">
                <font-awesome-icon icon="file-pdf" class="mr-2 text-muted" />
                Documento adjunto
              </mdbCardTitle>
              <mdbBtn
                v-if="puedePrevisualizar"
                size="sm"
                flat
                dark-waves
                icon="eye"
                class="m-0 px-2 py-2"
                @click="vistaPreviaActiva = !vistaPreviaActiva"
              >
                {{ vistaPreviaActiva ? 'Ocultar' : 'Vista previa' }}
              </mdbBtn>
            </div>
            <span class="font-weight-medium">{{ documento.name }}</span>
            <div v-if="vistaPreviaActiva && previewUrl" class="mt-3">
              <iframe :src="previewUrl" class="documento-vista-previa" />
            </div>
          </mdbCardBody>
        </mdbCard>
        <hr v-if="datosFactura" class="my-4">
        <mdbCard v-if="datosFactura" class="mb-3 card-bordered">
          <mdbCardBody>
            <div class="d-flex justify-content-between align-items-center mb-3">
              <mdbCardTitle class="mb-0">
                <font-awesome-icon icon="file-invoice" class="mr-2 text-muted" />
                Factura asociada
              </mdbCardTitle>
              <mdbBadge color="bg-primario" pill class="p-2">
                {{ datosFactura.est }}
              </mdbBadge>
            </div>

            <div class="row">
              <div class="col-12 col-sm-6">
                <span class="small-block">Factura</span>
                <span>#{{ datosFactura.fac }}</span>
              </div>
              <div class="col-12 col-sm-6">
                <span class="small-block">Método de pago</span>
                <span>{{ datosFactura.nom_met }}</span>
              </div>
              <div v-if="datosFactura.mep != 3" class="col-12 col-sm-6 mt-2">
                <span class="small-block">Referencia</span>
                <span>#{{ datosFactura.ref }}</span>
              </div>
              <div v-if="datosFactura.mep != 3" class="col-12 col-sm-6 mt-2">
                <span class="small-block">Banco</span>
                <span>{{ datosFactura.nom_ban }}</span>
              </div>
              <div class="col-12 col-sm-6 mt-2">
                <span class="small-block">Fecha recibido</span>
                <span>{{ datosFactura.fecRe }}</span>
              </div>
              <div class="col-12 col-sm-6 mt-2">
                <span class="small-block">Fecha depósito</span>
                <span>{{ datosFactura.fecDe }}</span>
              </div>
              <div class="col-12 col-sm-4 mt-2">
                <span class="small-block">Monto</span>
                <span class="font-weight-bold">{{ parseFloat(datosFactura.monRec).toFixed(2) }} Bs.</span>
              </div>
              <div class="col-12 col-sm-4 mt-2">
                <span class="small-block">Tasa</span>
                <span>{{ parseFloat(datosFactura.tas).toFixed(2) }} Bs.</span>
              </div>
              <div class="col-12 col-sm-4 mt-2">
                <span class="small-block">Moneda</span>
                <span>{{ datosFactura.nom_mon }}</span>
              </div>
            </div>

            <p v-if="datosFactura.obs" class="mt-3 mb-0">
              <font-awesome-icon icon="info-circle" class="mr-1 text-muted" />
              <strong>Observación:</strong> {{ datosFactura.obs }}
            </p>
          </mdbCardBody>
        </mdbCard>
        <p v-if="detalle.obs">
          <font-awesome-icon icon="comment-alt" class="mr-1 text-muted" />
          <strong>Observaciones:</strong> {{ detalle.obs }}
        </p>
      </div>
    </mdbModalBody>
    <mdbModalFooter>
      <div class="w-100 d-flex justify-content-between">
        <mdbBtn icon="cancel" dark-waves flat type="submit" class="m-0 px-3 py-4" @click="$emit('cerrarModal')">
          Cancelar
        </mdbBtn>
        <mdbBtn icon="check" type="submit" color="primario" class="m-0 px-3 py-4" @click="$emit('aceptarActividad')">
          Aceptar
        </mdbBtn>
      </div>
    </mdbModalFooter>
  </mdbModal>
</template>

<script>
import {
  mdbCard,
  mdbCardTitle,
  mdbCardBody,
  mdbBadge,
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
} from 'mdbvue';
import {apiPost} from '@/funciones/api.js';

export default {
  name: 'DetalleActividad',
  components: {
    mdbCard,
    mdbCardTitle,
    mdbCardBody,
    mdbBadge,
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
  },
  props: {
    mostrarModal: {
      type: Boolean,
      required: true,
    },
    detalle: {
      type: Object,
      required: true,
    },
    documento: {
      type: Object,
      default: null,
    },
    BancosPago: {
      type: Array,
      required: true,
    },
    MetodosPago: {
      type: Array,
      required: true,
    },
    MonedasPago: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      presentaciones: [],
      facturas: [],
      previewUrl: '',
      vistaPreviaActiva: false,
    };
  },
  methods: {
    liberarPreview() {
      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = '';
      }
      this.vistaPreviaActiva = false;
    },
    cargaIncial() {
      apiPost({s: 'presentacionesMv'}, '')
          .then((res) => {
            if (res.data.pre) {
              this.presentaciones = res.data.pre;
            }
          });
    },
    obtenerFacturas(id) {
      console.log('Obteniendo facturas para sucursal:', id);
      apiPost({s: 'facturasMv'}, 'suc=' + id)
          .then(({data}) => {
            this.facturas = data.fac;
          });
    },
  },
  watch: {
    'documento': {
      handler(nuevoDocumento) {
        this.liberarPreview();
        if (nuevoDocumento) {
          this.previewUrl = URL.createObjectURL(nuevoDocumento);
        }
      },
      immediate: true,
    },
    'detalle.pago': {
      handler(nuevoPago) {
        if (nuevoPago && nuevoPago.fac) {
          this.obtenerFacturas(this.detalle.suc);
        }
      },
      immediate: true,
    },
  },
  computed: {
    puedePrevisualizar() {
      return this.documento && /\.(pdf|jpe?g|png|gif|webp)$/i.test(this.documento.name || '');
    },
    preDetalle() {
      if (!this.detalle.pedido || !this.detalle.pedido.presentaciones) {
        return {};
      }
      const datosAgrupados = this.presentaciones.reduce((acumulador, item) => {
        if (this.detalle.pedido.presentaciones[item.id_pre]) {
          const categoria = item.nom_cat;
          const idProducto = item.id_pro_pre;

          if (!acumulador[categoria]) {
            acumulador[categoria] = {};
          }

          if (!acumulador[categoria][idProducto]) {
            acumulador[categoria][idProducto] = [];
          }

          const itemEnriquecido = {
            ...item,
            ...this.detalle.pedido.presentaciones[item.id_pre],
          };

          acumulador[categoria][idProducto].push(itemEnriquecido);
        }
        return acumulador;
      }, {});
      return datosAgrupados;
    },
    facturaPed() {
      if (!this.detalle.pago || !this.detalle.pago.fac) return null;
      const factura = this.facturas.find((fac) => fac.id_fac == this.detalle.pago.fac);
      return factura || null;
    },
    datosFactura() {
      if (this.detalle.pago) {
        const banco = this.BancosPago.find((banco) => banco.id_cba == this.detalle.pago.cba);
        const metodo = this.MetodosPago.find((metodo) => metodo.id_mep == this.detalle.pago.mep);
        const moneda = this.MonedasPago.find((moneda) => moneda.id_mon == this.detalle.pago.mone);
        return {
          ...this.detalle.pago,
          nom_ban: banco ? banco.nom_cba : '',
          nom_met: metodo ? metodo.nom_mep : '',
          nom_mon: moneda ? moneda.nom_mon : '',
        };
      }
      return null;
    },
  },
  mounted() {
    this.cargaIncial();
  },
  beforeDestroy() {
    this.liberarPreview();
  },
};
</script>

<style lang='scss' scoped>
  .documento-vista-previa {
    border: 1px solid $gris-tr-borde;
    height: 400px;
    width: 100%;
  }
</style>
